/* common
========================================================= */
import { pageTop } from './pageTop';
import { floatingButton } from './floatingButton';
import { smoothScroll } from './smoothScroll';
import { fadeIn } from './fadeIn';
import { form } from './form';
import { accordion } from './accordion';

export function common($) {
  pageTop($);
  floatingButton($);
  smoothScroll($);
  fadeIn($);
  form($);
  accordion($);
}
